import React from "react";

const Title = ({ children, borderColor='border-dark', textColor='text-dark' }) => {
  return (
    <div className={`d-flex d-inline-flex mt-4 border-bottom ${borderColor} mx-3 px-5`}>
      <h1 className={textColor}>{children}</h1>
    </div>
  );
};

export default Title;
